import API from 'services/API';

export default function uploadAvatar() {
  return API.request({
    method: 'DELETE',
    url: '/profile/deletePhoto',
  });
}
